import { type RefObject } from 'react';
import { ArrowSection, type ArrowType } from './ArrowSection';
import { CharacterPalette } from './CharacterPalette';
import './PreviewArrowPanel.css';

interface PreviewArrowPanelProps {
  topText: string;
  bottomText: string;
  arrowType: ArrowType;
  onTopTextChange: (text: string) => void;
  onBottomTextChange: (text: string) => void;
  onArrowTypeChange: (type: ArrowType) => void;
  reagentsInputRef: RefObject<HTMLInputElement | null>;
  conditionsInputRef: RefObject<HTMLInputElement | null>;
  characterPalette: {
    activeInput: 'conditions' | 'reagents' | null;
    handleCharacterSelect: (char: string) => void;
    handleInputFocus: (inputType: 'reagents' | 'conditions') => void;
    handleInputBlur: () => void;
  };
}

/**
 * In-preview arrow labels + symbols (always visible).
 */
export function PreviewArrowPanel({
  topText,
  bottomText,
  arrowType,
  onTopTextChange,
  onBottomTextChange,
  onArrowTypeChange,
  reagentsInputRef,
  conditionsInputRef,
  characterPalette,
}: PreviewArrowPanelProps) {
  return (
    <section className="preview-arrow-panel build-display-card" aria-label="Arrow labels and type">
      <div className="preview-arrow-panel-content">
        <div
          className="build-arrow-card-symbols-panel"
          role="region"
          aria-label="Symbols for reagents and conditions"
        >
          <p className="preview-arrow-panel-symbols-label">Special Characters</p>
          <CharacterPalette
            embedded
            onCharacterSelect={characterPalette.handleCharacterSelect}
            showCopyFeedback={!characterPalette.activeInput}
          />
        </div>

        <ArrowSection
          fieldIdSuffix="-inline-preview"
          topText={topText}
          bottomText={bottomText}
          onTopTextChange={onTopTextChange}
          onBottomTextChange={onBottomTextChange}
          arrowType={arrowType}
          onArrowTypeChange={onArrowTypeChange}
          reagentsRef={reagentsInputRef}
          conditionsRef={conditionsInputRef}
          onReagentsFocus={() => characterPalette.handleInputFocus('reagents')}
          onConditionsFocus={() => characterPalette.handleInputFocus('conditions')}
          onReagentsBlur={characterPalette.handleInputBlur}
          onConditionsBlur={characterPalette.handleInputBlur}
        />
      </div>
    </section>
  );
}
